if(!customElements.get('slider-component')) {
  customElements.define(
    'slider-component',
    class SliderComponent extends HTMLElement {
      #sliderEl;
      #sliderInstance;
      
      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        const optionsString = this.querySelector('[type="application/json"]')?.textContent;
        const sliderOptions = optionsString 
          ? JSON.parse(optionsString) 
          : {
            slidesPerView: 1,
            spaceBetween: 12,
            breakpoints: {
              768: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 4,
                gap: 20
              }
            }
          };
        
        if(this.dataset.navigation === "true") {
          sliderOptions["navigation"] = {
            prevEl: this.parentNode.querySelector('.slider-button.prev'),
            nextEl: this.parentNode.querySelector('.slider-button.next'),
          };
        }

        if(this.dataset.pagination === "true") {
          sliderOptions["pagination"] = {
            el: this.parentNode.querySelector('.slider-pagination'),
            type: "bullets",
            clickable: true
          };
        }

        this.mountSlider(sliderOptions);
      }

      mountSlider(options) {
        if(!this.#sliderEl) {
          console.error('[slider-component]: no slider element found.');
          return;
        }
        
        this.#sliderInstance = new Swiper(this.#sliderEl, options);
      }
    }
  );
}